import { defineComponent as o, computed as r } from "vue";
import { isArray as t } from "lodash-es";
import { hashCodeOf as i } from "@sunrise/shared";
const s = o({
  name: "CsCheckbox",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    name: { type: String, required: !0 },
    modelValue: [Array, Boolean],
    id: {
      type: String
    },
    value: {
      type: String,
      required: !0
    },
    showError: Boolean,
    errorMsg: String,
    isDisabled: Boolean
  },
  emits: ["update:modelValue"],
  setup(e, { emit: l }) {
    const n = e.id || m(e.value + e.name), u = r(() => t(e.modelValue) ? e.modelValue.includes(e.value) : e.modelValue);
    function d() {
      if (!t(e.modelValue)) {
        l("update:modelValue", !e.modelValue);
        return;
      }
      const a = [...e.modelValue];
      u.value ? a.splice(a.indexOf(e.value), 1) : a.push(e.value), l("update:modelValue", a);
    }
    return {
      finalId: n,
      checked: u,
      onChange: d
    };
  }
});
function m(e) {
  return i(e).toString();
}
export {
  s as default
};
